import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {map} from "rxjs/operators";
import {USER_EVENT_TYPE} from "../constants";
import {AuthService} from "./auth.service";
import {EventTrackingService} from "./event-tracking.service";
import {UtilitiesService} from "./utilities.service";
import {WrenchApiService} from "./wrench-api.service";

@Injectable()
export class CatalogService extends WrenchApiService {

    constructor(
        protected http: HttpClient,
        protected authService: AuthService,
        protected router: Router,
        protected eventTrackingService: EventTrackingService) {

        super(http, authService, router, eventTrackingService);

    } // constructor()

    getCatalog(params: any, component: string, isAuthenticated = false) {
        const url = isAuthenticated ? 'getcatalogauthed' : 'getcatalog';
        const event = isAuthenticated ? USER_EVENT_TYPE.GET_CATALOG_AUTHED : USER_EVENT_TYPE.GET_CATALOG_UNAUTHED;
        return this.request('/catalog/' + url, params, component, event, !isAuthenticated)
            .pipe(map(CatalogService.modifyCatalog));
    } // getCatalog() {

    getCatalogAuthed(params: any, component: string) {
        return this.getCatalog(params, component, true);
    } // getCatalogAuthed()

    getCatalogUnauthed(params: any, component: string) {
        return this.getCatalog(params, component, false);
    } // getCatalogUnauthed()

    getAddons(params: any, component: string, isAuthenticated = false) {
        const url = isAuthenticated ? 'getproductaddonsauthed' : 'getproductaddons';
        const event = isAuthenticated ? USER_EVENT_TYPE.GET_CATALOG_AUTHED : USER_EVENT_TYPE.GET_CATALOG_UNAUTHED;
        return this.request('/job/' + url, params, component, event, !isAuthenticated)
            .pipe(map(CatalogService.modifyAddons));
    } // getAddons() {

    getAddonsAuthed(params: any, component: string) {
        return this.getAddons(params, component, true);
    } // getAddonsAuthed()

    getAddonsUnauthed(params: any, component: string) {
        return this.getAddons(params, component, false);
    } // getAddonsUnauthed()

    getCatalogSearchTags(component: string) {
        return this.request('/job/getcatalogsearchtags', {}, component, USER_EVENT_TYPE.LOAD_CATALOG_SEARCH_TAGS, true);
    } // getCatalogSearchTags()

    private static modifyAddons(response: any) {
        if (response.addons) {
            for (const addon of response.addons) {
                if (addon.service) {
                    CatalogService.modifyService(addon.service);
                    addon.serviceCode = addon.service.code;
                } else if (UtilitiesService.isNotEmpty(addon.options)) {
                    for (let option of addon.options) {
                        CatalogService.modifyService(option.service);
                    }
                }

            }
        }
        return response.addons;
    } // modifyAddons()

    private static modifyCatalog(response: any) {
        if (response.catalog) {
            for (let entry of response.catalog) {
                const productGroup = entry.productGroup;
                if (entry.service) {
                    CatalogService.modifyService(entry.service, productGroup);
                } else if (UtilitiesService.isNotEmpty(entry.options)) {
                    for (let option of entry.options) {
                        CatalogService.modifyService(option.service, productGroup);
                    }
                }
            }
        }
        return response;
    } // modifyCatalog()

    private static modifyService(service: any, productGroup = '') {
        service.serviceCode = service.code;
        service.hasParts = service.customerSuppliedParts;

        if (productGroup) {
            service.productGroup = productGroup;
        }

        const toRemove = ['id', 'transmission', 'drivetrain', 'vehicleType', 'fuelType', 'mileage', 'market', 'userId',
            'origin', 'status', 'createdBy', 'updateDate', 'createDate', 'payerId'];
        for (let remove of toRemove) {
            delete service[remove];
        }
    } // modifyService()

}
